import usFlag from "../assets/images/flags/us.jpg"
import saFlag from "../assets/images/flags/ar.jpg";

const languages = {

  en: {
    label: "English",
    flag: usFlag,
  },
  ar: {
    label: "Arabic",
    flag: saFlag

  }
}

export default languages
